// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "anytube.png",
    title: "AnyTube",
    description:
      "A website where user can upload and watch awesome videos.",
    tech_stack: ['Next.Js', 'TailwindCSS', 'NodeJs', 'TypeScript'],
    demo_url: "https://any-tube.netlify.app",
  },
  {
    img: "diy.png",
    title: "#DIY",
    description:
      "A website where users have varity of DIY Products for kids.",
    tech_stack: ['React', 'TailwindCSS', 'NodeJs', 'TypeScript'],
    demo_url: "https://hashdiy.netlify.app",
  },
  // {
  //   img: "shoe party.png",
  //   title: "Shoe Party",
  //   description:
  //     "An app where users have varity of shoe options to buy.",
  //   tech_stack: ['React', 'TailwindCSS', 'NodeJs', 'TypeScript'],
  //   demo_url: "https://shoeparty.netlify.app",
  // },
  // {
  //   img: "relocatebox.png",
  //   title: "relocateBox",
  //   description:
  //     "An app where users gets their easy and fast relocation services",
  //   tech_stack: ['React', 'CSS', 'NodeJs', 'Javascript'],
  //   demo_url: "https://relocatebox.netlify.app/",
  // },
  {
    img: "photomania.png",
    title: "photoMania",
    description: "A website to get HD stock images fetched from multiple Apis.",
    tech_stack: ['TypeScript', 'RapidApi', 'React', 'NodeJs'],
    demo_url: "https://photomaania.netlify.app/",
  },
  {
    img: "a-prime.png",
    title: "A-Prime(Amazon Prime Clone)",
    description:
      "A website where users can add, edit and delete their daily tasks.",
    tech_stack: ['JQuery', 'CSS', 'BootStrap', 'Javascript'],
    demo_url: "https://a-prime-amazon-prime-clone.vercel.app/",
  },
  // {
  //   img: "devedit.png",
  //   title: "devEdit",
  //   description:
  //     "An app where users can edit their photos",
  //   tech_stack: ['React', 'BootStrap', 'NodeJs', 'Javascript'],
  //   demo_url: "https://devedits.netlify.app/",
  // },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://www.svgrepo.com/show/354113/nextjs-icon.svg",
    name: "NextJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },
  {
    img: "https://www.svgrepo.com/show/452093/redux.svg",
    name: "Redux",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    name: "TypeScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  // {
  //   img: "jquery-icon.svg",
  //   name: "JQuery",
  // },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "RapidAPI_logo.svg",
    name: "RapidApi",
  },
  {
    img: "Tailwind_CSS_Logo.svg",
    name: "TailwindCSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "BootStrap",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    name: "C",
  },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //   name: "Java",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
  //   name: "MySQL",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
  //   name: "Material UI",
  // },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
  // {
  //   img: "data:image/png;base64,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",
  //   name: "Netlify",
  // },
];
